<ng-container *ngIf="actionSection">
	<div class="is-taller nav-padding">
		<div class="level">
			<div class="level-item">
				<button type="button" class="bofa--button secondary outlined ui-font" *ngIf="!firstSection"
					(click)="onClickPrevious()">Previous step</button>
			</div>
			<div *ngIf="!firstSection && !formSubmitted" class="level-region level-nav">
				<button type="button" class="bofa--button secondary dark-blue save-ie save-margin ui-font save-height"
					(click)="onClickSave()">Save</button>

				<button type="button" class="bofa--button secondary outlined ui-font"
					(click)="onClickSaveAndFinishLater()">Save
					and finish later</button>
			</div>
			<div class="level-item level-nav">
				<button type="button" class="bofa--button secondary no-margin-right dark-blue large ui-font font-size"
					*ngIf="!firstSection && !lastSection && !formSubmitted" (click)="onClickNext()">Save and
					continue</button>
				<button type="button" class="bofa--button secondary no-margin-right dark-blue large"
					*ngIf="!firstSection && !lastSection && formSubmitted" (click)="onClickNext()">Next</button>
			</div>
			<div class="level-item">
				<button type="button" class="bofa--button secondary dark-blue large" *ngIf="firstSection"
					(click)="onClickNext()">Start</button>
			</div>

			<div *ngIf="lastSection && !formSubmitted" class="level-item">
				<button type="button" (click)="onClickNext()" class="bofa--button primary large ui-font">Save and
					submit</button>
			</div>
		</div>
	</div>
</ng-container>